/**
 * Groq provider adapter.
 *
 * Client-side only, per project decision (static SPA on GitHub Pages, no
 * backend). The API key is read from a build-time env var and IS visible in
 * the shipped bundle — acceptable for this dev/personal-use version only.
 *
 * Every adapter in providers/ exports the same shape: { name, ask(query) }.
 * ask() resolves to a plain string answer, or null if the provider can't
 * help (missing key, network error, empty response) — the router moves on
 * to the next provider whenever null/an error comes back.
 */

const API_URL = "https://api.groq.com/openai/v1/chat/completions";
// llama-3.3-70b-versatile was deprecated by Groq (June 17, 2026) — Groq's
// docs recommend openai/gpt-oss-120b as the replacement. Override via
// REACT_APP_GROQ_MODEL if you want a different model.
const DEFAULT_MODEL = "openai/gpt-oss-120b";

const SYSTEM_PROMPT =
  "You are the AI fallback for smartcalcAi, a calculator chat app. Answer briefly and plainly. " +
  "If the question is actually a calculation, say so and suggest the user rephrase it as a direct " +
  "calculation query (e.g. '15% of 2500', 'emi for 5 lakh at 8.5% for 5 years').";

async function ask(query) {
  const apiKey = process.env.REACT_APP_GROQ_API_KEY;
  if (!apiKey || !query) return null;

  const model = process.env.REACT_APP_GROQ_MODEL || DEFAULT_MODEL;

  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiKey}`,
    },
    body: JSON.stringify({
      model,
      messages: [
        { role: "system", content: SYSTEM_PROMPT },
        { role: "user", content: query },
      ],
      max_tokens: 300,
      temperature: 0.4,
    }),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => null);
    console.error("Groq provider error:", res.status, error);
    return null;
  }
  const data = await res.json();
  const text = data?.choices?.[0]?.message?.content?.trim();
  return text || null;
}

const groqProvider = { name: "groq", ask };
export default groqProvider;
